import { type CanvasElementId } from '@blaze-runtime/engine-domain';

import { type ComponentValidationData } from '../io-data.models';
export function updateValidationDataMutably(
  validationDataMap: Record<CanvasElementId, ComponentValidationData>,
  elementId: CanvasElementId,
  data: Partial<ComponentValidationData>,
): void {
  validationDataMap[elementId] = {
    ...validationDataMap[elementId],
    ...data,
  };
}
